import { Typography } from "@mui/material";
export function getLayoutText(t, s = {}) {
  return (
    <Typography
      variant="body1"
      sx={{
        fontSize: "1.25rem",
        fontFamily: "Lato-Regular",
        lineHeight: 1.75,
        ...s,
      }}
    >
      {t}
    </Typography>
  );
}
